module.exports = __webpack_public_path__ + "img/icon_9.833dfa47.svg";